import {
  Button,
  Col,
  Input,
  Modal,
  QRCode,
  Row,
  Select,
  Typography,
} from "antd";
import "./addUserModal.scss";
import React, { useEffect, useState } from "react";
import { HandleErrors } from "../../utils/handleErrors";
import { toast } from "react-toastify";
import { GetReportFilterReq } from "../../interfaces/event.interface";
import { newReportService } from "../../services/report.service";
import { AdminCreateUserReq } from "../../interfaces/user.interface";
import { GetRoleRes } from "../../interfaces/role.interface";
import { getRolesService } from "../../services/role.service";
import { adminCreateUserService } from "../../services/user.service";
import PasswordStrengthBar from "react-password-strength-bar";


interface Props {
  show: boolean;
  onClose: () => void;
}

export const AddUserModal: React.FC<Props> = (props) => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState<AdminCreateUserReq>({
    email: "",
    email_verified: true,
    first_name: "",
    last_name: "",
    password: "",
    retry_password: "",
    username: "",
    roles: []
  });

  const [isPasswordStrong, setIsPasswordStrong] = useState(false);

  const [roles, setRoles] = useState<GetRoleRes[]>([]);

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    try {
      const res = await getRolesService({});
      setRoles(res.list);
    } catch (error) {
      HandleErrors(error);
    }
  };

  const submit = async () => {
    try {

      if(!data.first_name || !data.last_name || !data.username || data.roles.length == 0 || !data.password  || !data.retry_password){
        toast.error('مقادیر اجباری را وارد کنید')
        return
      }

      if(!isPasswordStrong){
        toast.error("رمز عبور ضعیف است")
        return
      }

      setLoading(true);

      const res = await adminCreateUserService(data);

      setData({
        email: "",
        email_verified: true,
        first_name: "",
        last_name: "",
        password: "",
        retry_password: "",
        username: "",
        roles: []
      });
      props.onClose();
      setShow(false);
      toast.success("کاربر جدید با موفقیت ثبت شد.");
      setLoading(false);
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  return (
    <div className="AddUserModal">
      <Modal
        destroyOnClose={true}
        title={"افزودن کاربر جدید"}
        onCancel={() => {
          setShow(false);
          props.onClose();
          setData({
            email: "",
            email_verified: true,
            first_name: "",
            last_name: "",
            password: "",
            retry_password: "",
            username: "",
            roles: []
          });
        }}
        open={show}
        footer={null}
        width={650}
      >
        <div className="AddUserModalContent">
          <Row justify={"space-between"}>
            <Col xs={11} className="input-box">
              <Typography.Text className="title"><span style={{color: 'red'}}>*</span>نام: </Typography.Text>
              <Input
                className="input"
                value={data.first_name}
                onChange={(e) => {
                  setData({
                    ...data,
                    first_name: e.target.value,
                  });
                }}
              />
            </Col>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">
                <span style={{color: 'red'}}>*</span>
                نام خانوادگی:
              </Typography.Text>
              <Input
                className="input"
                value={data.last_name}
                onChange={(e) => {
                  setData({
                    ...data,
                    last_name: e.target.value,
                  });
                }}
              />
            </Col>
          </Row>
          <Row justify={"space-between"}>
            <Col xs={11} className="input-box">
              <Typography.Text className="title"><span style={{color: 'red'}}>*</span>نام کاربری: </Typography.Text>
              <Input
                className="input"
                value={data.username}
                onChange={(e) => {
                  setData({
                    ...data,
                    username: e.target.value,
                  });
                }}
              />
            </Col>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">ایمیل: </Typography.Text>
              <Input
                className="input"
                value={data.email}
                onChange={(e) => {
                  setData({
                    ...data,
                    email: e.target.value,
                  });
                }}
              />
            </Col>
          </Row>
          <Row justify={"space-between"}>
            <Col xs={24} className="input-box">
              <Typography.Text className="title"><span style={{color: 'red'}}>*</span>نقش کاربری: </Typography.Text>
              <Select
                mode="multiple"
                variant="filled"
                size="large"
                options={roles.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                })}
                onChange={(e)=>{
                  setData({
                    ...data,
                    roles: e
                  })
                  
                }}
              />
            </Col>
          </Row>
          <Row justify={"space-between"}>
            <Col xs={11} className="input-box">
              <Typography.Text className="title"><span style={{color: 'red'}}>*</span>رمز عبور: </Typography.Text>
              <Input.Password
                className="input"
                value={data.password}
                onChange={(e) => {
                  setData({
                    ...data,
                    password: e.target.value,
                  });
                }}
              />
              <PasswordStrengthBar
                scoreWords={["ضعیف", "ضعیف", "متوسط", "خوب", "قوی"]}
                shortScoreWord={"خیلی ضعیف"}
                password={data.password}
                onChangeScore={(e)=>{
                  if(e >= 3){
                    setIsPasswordStrong(true)
                  }else{
                    setIsPasswordStrong(false)
                  }
                  
                }}
              />
            </Col>
            <Col xs={11} className="input-box">
              <Typography.Text className="title">
                <span style={{color: 'red'}}>*</span>
                تکرار رمز عبور:
              </Typography.Text>
              <Input.Password
                className="input"
                value={data.retry_password}
                onChange={(e) => {
                  setData({
                    ...data,
                    retry_password: e.target.value,
                  });
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={24} className="btn-box">
              <Button
                loading={loading}
                onClick={submit}
                block
                type="primary"
                className="btn"
              >
                ثبت
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};
